import React from 'react'
import classnames from './Content.module.scss'

type ContentProps = {
  children: React.ReactNode
}

export function Content({ children }: ContentProps) {
  return <div className={classnames.content}>{children}</div>
}
